import { SVGProps, Ref, forwardRef } from 'react';

export const RabotaByAppBrandSize48Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.695 2c6.407 0 9.612 0 12.059 1.246a11.44 11.44 0 0 1 5 5C46 10.693 46 13.898 46 20.305v7.39c0 6.407 0 9.612-1.246 12.059a11.44 11.44 0 0 1-5 5C37.307 46 34.102 46 27.695 46h-7.39c-6.407 0-9.612 0-12.059-1.246a11.44 11.44 0 0 1-5-5C2 37.307 2 34.102 2 27.695v-7.39c0-6.407 0-9.612 1.246-12.059a11.44 11.44 0 0 1 5-5C10.693 2 13.898 2 20.305 2z"
            fill="#E80200"
        />
        <path
            d="M36.637 21.295c0-1.09-.24-2.17-.709-3.178a8.3 8.3 0 0 0-2.021-2.693 9.5 9.5 0 0 0-3.026-1.8 10.3 10.3 0 0 0-3.568-.632H11.92V35h6.292v-5.402h7.543L29.896 35h6.741l-4.91-6.388c1.482-.713 2.721-1.769 3.586-3.057a7.65 7.65 0 0 0 1.324-4.26m-9.324 2.701h-9.1v-5.402h9.1c1.668 0 3.033 1.215 3.033 2.701s-1.365 2.701-3.033 2.701"
            fill="white"
        />
    </svg>
));
RabotaByAppBrandSize48Glyph.displayName = 'RabotaByAppBrandSize48Glyph';
